import { Tab } from './types.js';
import { toTab } from './utils.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** @internal */
export const useRightDrawerPref = (): UsePrefState<boolean> =>
  usePrefState('room.right.drawer', false);

/** @internal */
export function useRightTabPref(): UsePrefState<Tab> {
  return usePrefState('room.right.tab', Tab.Controls, {
    deserialize: toTab
  });
}
